import React, { useState, useEffect } from "react";
import { useApp } from "context";
import { IProvider } from "interfaces";
import { Custom, Item, Modal, Progress } from "components";
import { Box } from "@mui/material";
import { Helpers } from "utils";

type Props = {
  opened: boolean;
  onOpen: () => void;
  onClose: () => void;
  // TODO: it may be improved (currently being used to force the updated of the appointments)
  incrementComponent: number;
};

export const Provider = (props: Props) => {
  const { t, service } = useApp();

  const [providers, setProviders] = useState<IProvider[]>([]);

  useEffect(() => {
    findProviders();
  }, [props.incrementComponent]);

  const findProviders = async () => {
    const response = await service.provider.slice();
    setProviders(response.filter((item: IProvider) => item.favourite));
  };

  const handleRemove = (index: number) =>
    setProviders(providers.filter((_, i) => i !== index));

  return (
    <Custom.Card
      sx={{ height: 305 }}
      title={t.title.patient.provider}
      action={
        <>
          <Custom.Button size="small" variant="outlined" onClick={props.onOpen}>
            {t.action.view_all}
          </Custom.Button>
          <Modal.Provider opened={props.opened} onClose={props.onClose} />
        </>
      }
    >
      <Box sx={{ position: "relative" }}>
        {providers ? (
          providers.length > 0 ? (
            providers.map((item: IProvider, i: number) => {
              return (
                <Item.Provider
                  key={item.providerId}
                  index={i}
                  provider={item}
                  onRemove={handleRemove}
                />
              );
            })
          ) : (
            <Progress.NoRecord
              height={200}
              message={t.message.placeholder.no_favourite_provider}
            />
          )
        ) : (
          Helpers.generateArray(4).map((_, i) => (
            <Progress.PlaceholderItem key={i} />
          ))
        )}
      </Box>
    </Custom.Card>
  );
};
